import { ReactNode } from "react";

interface IInfoAreaTable {
    title: string,
    children: ReactNode;
}

const InfoAreaTable = ({ title, children }: IInfoAreaTable) => {
    return (
        <div className='flex tablet:flex-col items-start tablet:items-start'>
            <p className='w-[170px] text-lg shrink-0'>{title}</p>
            <div className='flex-1 bg-base rounded min-h-12'>
                {children}
            </div>
        </div>
    )
}

export default InfoAreaTable